// React imports
import React from 'react';

// Project imports
import OpportunityOneOffBaseScreen from '../OpportunityOneOffBaseScreen';
import OpportunityOneOffFreeTextBuilder from './OpportunityOneOffFreeTextBuilder';
import OpportunityPreviewAndSendOneOffEmail from '../OpportunityPreviewAndSendOneOffEmail';

function OpportunityOneOffFreeTextScreen(props) {
    return (
        <OpportunityOneOffBaseScreen
            type='one-off-free-text'
            Builder={OpportunityOneOffFreeTextBuilder}
            PreviewAndSend={OpportunityPreviewAndSendOneOffEmail}
            {...props}
        />
    );
}

export default OpportunityOneOffFreeTextScreen;

